import axios from "axios";
import { getToken } from "../../Utils/UpdateUsersState";

const getSystemConfigurations = async () => {
  try {
    const token = getToken();

    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin_panel/system_configs/`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response;
  } catch (error) {
    console.error("System Configurations fetch error:", error);
    throw error;
  }
};

const getSpeedLimit = async () => {
  try {
    const token = getToken();

    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin_panel/config/speed_limit`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response;
  } catch (error) {
    console.error("Speed Limit fetch error:", error);
    throw error;
  }
};

const getSafeSpeed = async () => {
  try {
    const token = getToken();

    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin_panel/config/safe_speed`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response;
  } catch (error) {
    console.error("Safe Speed fetch error:", error);
    throw error;
  }
};

const getHighTheftAreaRadius = async () => {
  try {
    const token = getToken();

    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin_panel/config/high_theft_area_radius`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response;
  } catch (error) {
    console.error("Hight Theft Area Radius fetch error:", error);
    throw error;
  }
};

const getHighTheftPeriod = async () => {
  try {
    const token = getToken();

    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin_panel/config/high_theft_period`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response;
  } catch (error) {
    console.error("Hight Theft Period fetch error:", error);
    throw error;
  }
};

const getTheftArea = async () => {
  try {
    const token = getToken();

    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin_panel/config/high_theft_area`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response;
  } catch (error) {
    console.error("Hight Theft Period fetch error:", error);
    throw error;
  }
};

const editSpeedLimit = async (name, max_speed) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}admin_panel/config/speed_limit/`,
      { name, max_speed },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      },
    );

    return res;
  } catch (e) {
    console.log(e, "error");
    throw e;
  }
};

const editSafeSpeed = async (name, safe_speed) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}admin_panel/config/safe_speed/`,
      { name, safe_speed },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      },
    );

    return res;
  } catch (e) {
    console.log(e, "error");
    throw e;
  }
};

const editHighTheftAreaRadius = async (area_radius) => {
  try {
    const token = getToken();

    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}admin_panel/config/high_theft_area_radius/`,
      { area_radius },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response;
  } catch (error) {
    console.error("Hight Theft Area Radius error:", error);
    throw error;
  }
};

const editHarshDriving = async (speed_delta_threshold, speed_time_window) => {
  try {
    const token = getToken();

    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}admin_panel/config/harsh_driving_config/`,
      {
        speed_delta_threshold,
        speed_time_window,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response;
  } catch (error) {
    console.error("Harsh Driving Config error:", error);
    throw error;
  }
};

const editDetectionTime = async (detection_window_minutes) => {
  try {
    const token = getToken();

    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}admin_panel/config/detection_window_minutes/`,
      {
        detection_window_minutes,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response;
  } catch (error) {
    console.error("Detection Time error:", error);
    throw error;
  }
};

const editAlertResetTime = async (alert_reset_minutes) => {
  try {
    const token = getToken();

    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}admin_panel/config/alert_reset_minutes/`,
      {
        alert_reset_minutes,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response;
  } catch (error) {
    console.error("Alert Reset Time error:", error);
    throw error;
  }
};

const editMultipleIgnitionOnOffThreshold = async (multiple_ignition_on_off_threshold) => {
  try {
    const token = getToken();

    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}admin_panel/config/multiple_ignition_on_off_threshold/`,
      {
        multiple_ignition_on_off_threshold,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response;
  } catch (error) {
    console.error("Multiple Ignition On/Off Threshold error:", error);
    throw error;
  }
};

const editRiskRetention = async (retention_time, factors) => {
  try {
    const token = getToken();

    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}admin_panel/config/risk_retention_config/`,
      {
        retention_time,
        factors,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response;
  } catch (error) {
    console.error("Risk Retention Config error:", error);
    throw error;
  }
};

const editIgnitionGatedFactors = async (factors) => {
  try {
    const token = getToken();

    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}admin_panel/config/ignition_gated_factors/`,
      {
        factors,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response;
  } catch (error) {
    console.error("Ignition Gated Factors Config error:", error);
    throw error;
  }
};

const addTheftArea = async (points, action = "append") => {
  try {
    const token = getToken();

    const payload = {
      name: "high_theft_area_entry",
      points,
      action,
    };

    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}admin_panel/config/high_theft_area/`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response;
  } catch (error) {
    console.error("High Theft Area add error:", error);
    throw error;
  }
};

const deleteTheftArea = async (points, action = "delete") => {
  try {
    const token = getToken();

    const payload = {
      name: "high_theft_area_entry",
      points,
      action,
    };

    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}admin_panel/config/high_theft_area/`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response;
  } catch (error) {
    console.error("High Theft Area delete error:", error);
    throw error;
  }
};

const editHighTheftPeriod = async (payload) => {
  try {
    const token = getToken();

    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}admin_panel/config/high_theft_period/`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response;
  } catch (error) {
    console.error("Hight Theft Period update error:", error);
    throw error;
  }
};

const syncGeofence = async () => {
  try {
    const token = getToken();

    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}user_panel/sync_geofences/`,

      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response;
  } catch (error) {
    console.error("Sync Geofence  error:", error);
    throw error;
  }
};

export {
  getSystemConfigurations,
  getSpeedLimit,
  getSafeSpeed,
  getHighTheftAreaRadius,
  getHighTheftPeriod,
  getTheftArea,
  editSpeedLimit,
  editSafeSpeed,
  editHighTheftAreaRadius,
  editHarshDriving,
  editDetectionTime,
  editAlertResetTime,
  editMultipleIgnitionOnOffThreshold,
  editRiskRetention,
  editIgnitionGatedFactors,
  addTheftArea,
  deleteTheftArea,
  editHighTheftPeriod,
  syncGeofence,
};
